import { useState, useEffect } from "react"

import { Box, FormGroup, FormControlLabel, Switch } from "@mui/material"

import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"

import Loading from "../../Loading"
import useNotification from "../../Notification"

import api from "../../../api"

import { getSession, saveSession } from "../../../auth"

const Auth2FA = ({ enterpriseId }) => {
	const [loading, setLoading] = useState(false)
	const [email, setEmail] = useState(false)
	const [whatsapp, setWhatsApp] = useState(false)

	const updateSettings = async () => {
		setLoading(true)
		const res = await api.patch(`/api/enterprises/${enterpriseId}/`, {
			"settings": {
				"email_2fa": email,
				"whatsapp_2fa": whatsapp
			}
		})
		setLoading(false)

		if (res.status !== 200) {
			useNotification(
				"Ops!",
				"Algo deu errado, tente novamente.",
				"danger"
			);	
			return
		}

		const session = getSession()
		session.profile.enterprise.settings.email_2fa = email
		session.profile.enterprise.settings.whatsapp_2fa = whatsapp
		saveSession(session)

		useNotification(
			"Sucesso!",
			"As configurações foram salvas com sucesso.",
			"success"
		);
	}

	useEffect(() => {
		setEmail(getSession().profile.enterprise.settings.email_2fa)
		setWhatsApp(getSession().profile.enterprise.settings.whatsapp_2fa)
	}, [])

    return (
        <Box className="input-settings" sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Loading loading={loading} />
            <Box className="category-title">
   				Canais
   			</Box>
            <FormGroup sx={{ marginLeft: "1rem", marginBottom: "-1rem" }}>
				<FormControlLabel control={
					<Switch
						color="primary"
						checked={email}
						onChange={() => setEmail(! email)}
                    />
				} 
				label="E-mail" />
			</FormGroup>
            <FormGroup sx={{ marginLeft: "1rem" }}>
				<FormControlLabel control={
					<Switch
						color="primary"
						checked={whatsapp}
						onChange={() => setWhatsApp(! whatsapp)}
                    />
				} 
				label="WhatsApp" />
			</FormGroup>
            <LoadingButton
                style={{ width: "fit-content" }}
                onClick={updateSettings}
                loading={loading}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="contained"
            >
                Salvar
            </LoadingButton>
    	</Box>
    )
}


export default Auth2FA
